const toggleReorderButton = document.querySelector('.product-info__reorder-button');

//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
  if (swat) {
    let lid = null; // List ID 
    let reorderList = null;
    let isProductInList = false;
    const product = {
      epi: +toggleReorderButton.dataset.variantId,
      empi: +toggleReorderButton.dataset.productId,
      du: toggleReorderButton.dataset.productUrl,
    };

    let onSuccess = async function(lists) {
      if (lists.length > 0) {
        reorderList = lists.find(list => list.lname === 'Reorder Pad');
        lid = reorderList?.lid;
      }

      if (lid) {
        reorderList.listcontents.forEach(function(el) {
          if (el.epi === product.epi) {
            isProductInList = true;
          }
        });
        if (isProductInList) {
          toggleReorderButton.textContent = 'Remove from Reorder Pad';
          toggleReorderButton.classList.add('swym-added');
        } else {
          toggleReorderButton.textContent = 'Add to Reorder Pad';
          toggleReorderButton.classList.remove('swym-added');
        }
      } else {
        try {
          let listConfig = {
            "lname": "Reorder Pad", // unique list name.
          };
          await swat.createList(listConfig);
        } catch (error) {
          console.log('Error while creating reorder pad', error);
        }
      }
    }
    
    let onError = function(error) {
      console.log("Error while fetching all Lists", error);
    }
    
    // Call `fetchLists` function
    swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError
    });

    if (isProductInList) {
      toggleReorderButton.textContent = 'Remove from Reorder Pad';
      toggleReorderButton.classList.add('swym-added');
    } else {
      toggleReorderButton.textContent = 'Add to Reorder Pad';
      toggleReorderButton.classList.remove('swym-added');
    }
  
    document.querySelector('.product-info__reorder-button').addEventListener('click', function() {
      if (lid && isProductInList) {
        swat.deleteFromList(
          lid,
          product,
          function(response) {
            toggleReorderButton.textContent = 'Add to Reorder Pad';
            toggleReorderButton.classList.remove('swym-added');
            isProductInList = false;
          },
          function(error) {
            console.log('Error while removing product from reorder list', error);
          }
        );
      }
    });

    swat.evtLayer.addEventListener('sw:addedtowishlist', function(e) {
      toggleReorderButton.textContent = 'Remove from Reorder Pad';
      toggleReorderButton.classList.add('swym-added');
      isProductInList = true;
    });
  }
};

const mutationCallback = (mutationsList) => {
  for (const mutation of mutationsList) {
    if (
      mutation.type !== "attributes" ||
      mutation.attributeName !== "data-variant-id"
    ) {
      return
    }
    onSwymLoadCallback(window._swat);
  }
}

const observer = new MutationObserver(mutationCallback);
observer.observe(toggleReorderButton, { attributes: true });

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);
